import { MONTH_NAMES, type CalEvent } from '@circle/shared';

export const MONTH_SHORT = MONTH_NAMES.map((m) => m.slice(0, 3));

export function formatDayMonth(month: number, day: number): string {
  return `${day} ${MONTH_SHORT[month - 1] ?? '?'}`;
}

/** Age turning in the view year, or undefined when no birth year is known. */
export function ageIn(event: CalEvent, viewYear: number): number | undefined {
  if (event.kind !== 'birthday' || event.year === undefined) return undefined;
  return viewYear - event.year;
}

/** Float subtitle: just the age ("40"), or nothing. */
export function ageText(event: CalEvent, viewYear: number): string | undefined {
  const age = ageIn(event, viewYear);
  return age === undefined || age < 0 ? undefined : String(age);
}

/** Detail line: "turns 40 on 12 Mar" / "turned 40 on 12 Mar", or the plain date. */
export function detailText(event: CalEvent, viewYear: number, today = new Date()): string {
  const date = formatDayMonth(event.month, event.day);
  const age = ageIn(event, viewYear);
  if (age === undefined || age < 0) return date;
  const past = isBefore(viewYear, event.month, event.day, today);
  return `${past ? 'turned' : 'turns'} ${age} on ${date}`;
}

function isBefore(year: number, month: number, day: number, today: Date): boolean {
  const t = [today.getFullYear(), today.getMonth() + 1, today.getDate()] as const;
  if (year !== t[0]) return year < t[0];
  if (month !== t[1]) return month < t[1];
  return day < t[2];
}

/** True when the given calendar date falls on a Saturday or Sunday. */
export function isWeekend(year: number, month: number, day: number): boolean {
  const dow = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  return dow === 0 || dow === 6;
}
